import { CommandResult } from "../../../Common/domain/src/api/commandResult";
import {
    GetAssociationFlowState, START_ASSOCIATION_FLOW, START_ASSOCIATION_FLOW_FAIL
} from "../../domain/association/index";

export const initialState: GetAssociationFlowState = {
    result: new CommandResult({ isValid: false }),
  };
  
export default function associationFlow(state = initialState, action: any) {
    switch (action.type) {
      case START_ASSOCIATION_FLOW:
        return {
          ...state,
          result: action.payload,
        };
        case START_ASSOCIATION_FLOW_FAIL:
          return { ...state, result: action.payload };
      default:
        return state;
    }
};